// Whenever a form is submitted, add the "pulse" animation to the button.
$('form').on('submit', (event) => {
    $(event.target).find('[type=submit]:not(.no-animation)').addClass('animate-pulse');
});
